import { BTM } from 'core/constants/products'

function setDurationToBTMPlans(quoteResponse) {
  if (quoteResponse.plansByType[BTM]) {
    quoteResponse.plansByType[BTM].forEach(id => {
      const plan = quoteResponse.plans[id]
      plan.duration = plan.durations[0]
    })
  }
}

export default setDurationToBTMPlans
